import styled from 'styled-components/macro';
import { useCartContext } from '../../../hooks/context/useCartContext';
import { breakpoint } from '../../../styles/constants';
import { MobileOnly } from '../../layout/nav/Nav';
import { CartDesktopBar } from './CartDesktopBar';
import { CartItem } from './CartItem';
import { CartItemDesktop } from './CartItemDesktop';
export const CartItemList = () => {
  const { cart, serverCartItems } = useCartContext();
  if (!serverCartItems) return null;

  return (
    <Wrapper>
      <CartDesktopBar />

      <ul>
        {serverCartItems.map((item, index) => (
          <li key={item.variantId}>
            <CartItemDesktop
              item={item}
              quantity={cart.items[index].quantity}
            />
            <MobileOnly>
              <CartItem item={item} quantity={cart.items[index].quantity} />
            </MobileOnly>
          </li>
        ))}
      </ul>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-bottom: 1.25rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.white};
  flex-grow: 1;

  > ul {
    gap: 0.625rem;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${breakpoint}) {
    flex-grow: unset;
    > ul {
      display: block;
    }

    li {
      margin-bottom: 0.625rem;
    }
  }
`;
